import React, { PropsWithChildren } from 'react';
import InfoBox from 'utils/components/InfoBox/InfoBox';
import { useCapsuleBoundSymbol } from 'widgets/tiles/components/tile/hooks';

export type SymbolFromConfigOrPortfolioLinkedStatusProps = PropsWithChildren<{
    warning?: JSX.Element;
}>;

export function SymbolFromConfigOrPortfolioLinkedStatus(
    props: SymbolFromConfigOrPortfolioLinkedStatusProps
) {
    const { children, warning } = props;

    const { symbol } = useCapsuleBoundSymbol();

    if (symbol) {
        return <>{children}</>;
    }

    return (
        <InfoBox
            info={warning}
            className="SymbolFromConfigOrPortfolioLinkedStatus"
        />
    );
}
